'use client';
import styled from 'styled-components';

export const StyledForm = styled.form`
  background: ${props => props.theme.colors.background.base};
  flex: 1;
  display: grid;
  grid-gap: ${props => props.theme.spacing(12)};
  justify-items: center;
  overflow: auto;
  margin-bottom: 74px; /* 74px for navigation bar */
`;
